var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{ref:"agGridExSmart",staticClass:"elevation-2",class:{
    'ag-theme-alpine-dark': _vm.$vuetify.theme.dark,
    'ag-theme-alpine': !_vm.$vuetify.theme.dark
  },staticStyle:{"width":"100%"},style:({ height: _vm.gridHeight }),attrs:{"id":'agGridExSmart_' + _vm.format,"modules":_vm.allModules,"gridOptions":_vm.gridOptions,"columnDefs":_vm.columnDefs,"defaultColDef":_vm.defaultColDef},on:{"grid-ready":_vm.onGridReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }